module.exports = __webpack_public_path__ + "img/pf.d6017afe.svg";